import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SignalField} from '@models/pages/interactive-data-analysis/interactive-data-analysis-signals';
import {InteractiveDataAnalysisConfig} from '@models/pages/interactive-data-analysis/interactive-data-analysis-config';

@Injectable({
  providedIn: 'root'
})
export class SignalsNotificationService {

  private behaviourSubject = new BehaviorSubject<SignalField[] | undefined>(undefined);
  signalsNotification = this.behaviourSubject.asObservable();

  private interactiveDataAnalysisConfigBehaviourSubject = new BehaviorSubject<InteractiveDataAnalysisConfig | undefined>(undefined);
  interactiveDataAnalysisConfigNotification = this.interactiveDataAnalysisConfigBehaviourSubject.asObservable();

  broadcast(signals: SignalField[]) {
    this.behaviourSubject.next(signals);
  }

  broadcastInteractiveDataAnalysisConfigNotification(interactiveDataAnalysisConfig: InteractiveDataAnalysisConfig) {
    this.interactiveDataAnalysisConfigBehaviourSubject.next(interactiveDataAnalysisConfig);
  }
}